<template>
  <div>
    <div class="view_header">
      <div style="text-align: center;color: #bd1a2d; text-shadow:white 2px -1px, white 0 1px, white 1px 0, white 3px -2px;font-size: 48px;
padding: 9px 0 0 10px;letter-spacing: 9px">新闻发布会</div>
      <div style="text-align: center;margin-top: 11px;font-size: 19px">PRESS CONFERENCE</div>
    </div>
    <div v-if="!published"  class="self_adaption_mainWid1200" style="height: 550px" ref="content">
      <div style="font-size: 30px;text-align: center;line-height: 550px;color: red">发布会暂未开始，请耐心等待！</div>
    </div>
    <div v-else class="self_adaption_mainWid1200" ref="content">
      <div class="description">
        <div style="flex: 0.56">
          <el-carousel height="400px">
            <el-carousel-item class="el-car-item" v-for="(item, index) in images" :key="'img'+index">
              <div class="description_right_img">
                <img :src="item.img" alt="" style="width: 100%;height:100%;object-fit: cover;"/>
              </div>
              <div class="description_right_text">
                <div style="margin-left: 35px;font-size: 16px">{{item.title}}</div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div style="flex: 0.44;margin-left: 10px;height: 400px;">
          <div class="description_right_title_text">{{description.title}}</div>
          <div class="description_right_content">
            <div class="description_right_content_left">主办单位：</div>
            <div>{{description.unit}}</div>
          </div>
          <div class="description_right_content">
            <div class="description_right_content_left">发 言 人：</div>
            <div>
              <div v-for="(item , index) in description.spokesman" :key="'spokesman'+index"
                   style=" margin-bottom: 5px;">
                {{item}}
              </div>
            </div>
          </div>
          <div class="description_right_content">
            <div class="description_right_content_left">主 持 人：</div>
            <div>
              <div v-for="(item , index) in description.host" :key="'host'+index"
                   style=" margin-bottom: 5px;">
                {{item}}
              </div>
            </div>
          </div>
          <div class="description_right_content">
            <div class="description_right_content_left">会议时间：</div>
            <div>{{description.startTime}}</div>
          </div>
          <div class="description_right_content">
            <div class="description_right_content_left">会议地点：</div>
            <div>{{description.address}}</div>
          </div>
          <div class="description_right_content">
            <div class="description_right_content_left" style="flex: 1">会议内容：</div>
            <div style="flex: 5.2">
              <div class="description_right_content_right">
                {{description.intro}}
              </div>
              <div style="color: red;float: right" @click="introDetail">[详情]</div>
            </div>
          </div>
        </div>
      </div>
      <div  class="view_title" style="margin-bottom: 30px"></div>
      <div  class="content" style="height: 400px;overflow-y: scroll" ref="contentBody" @scroll="scrolling()">
        <div ref="content">
          <div style="margin-bottom: 20px" v-for="(item, index) in content" :key="'content' + index">
            <div v-if="item.type === 0 && item.speechType === 0"
                 style="background-color: #c84444;width:fit-content;border-radius :0 10px;padding: 5px;font-family:黑体;font-size: 16px;color: white; margin-bottom: 20px">
              {{item.speaker}}（主持人）
            </div>
            <div v-else-if="item.type === 0 && item.speechType === 2"
                 style="background-color: #c84444;width:fit-content;border-radius :0 10px;padding: 5px;font-family:黑体;font-size: 16px;color: white; margin-bottom: 20px">
              {{item.speaker}}（主持人）
            </div>
            <div v-else-if="item.type === 1 && item.speechType === 0"
                 style="background-color: #c84444;width:fit-content;border-radius :0 10px;padding: 5px;font-family:黑体;font-size: 16px;color: white; margin-bottom: 20px">
              {{item.speaker}}
            </div>
            <div v-else-if="item.speechType === 1"
                 style="background-color: #8995ac;width:fit-content;border-radius :0 10px;padding: 5px;font-family:黑体;font-size: 16px;color: white; margin-bottom: 20px">
              {{item.speaker}}
            </div>
            <div v-else
                 style="background-color: #dabb85;width:fit-content;border-radius :0 10px;padding: 5px;font-family:黑体;font-size: 16px;color: white; margin-bottom: 20px">
              {{item.speaker}}
            </div>
            <div style="white-space: pre-wrap; word-wrap: break-word;line-height: 30px;margin-bottom: 5px" v-html="item.content">

            </div>
<!--            <div style="color: #999999;font-family:黑体;font-size: 16px">{{item.issueDate}}</div>-->
          </div>
        </div>
      </div>
    </div>

    <!-- 介绍详情 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false" :title="introDialogTitle"
               :visible.sync="introDialogVisible" width="70%" center>
      <div style="font-size: 18px;font-weight: 400;text-indent:2em;line-height: 33px">{{description.intro}}</div>
      <div class="submitDiv" style="justify-content: center">
        <el-button @click="introDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { issueInfoViewFront, speechListFront, taskIssueStatus} from '@/api/axiosUrl';
  import {getYearMonthDay} from '@/utils/jsApi.js'
import {lineBrake2Dom} from "@/utils/tools";

  export default {
    name: 'Progress',
    data() {
      return {
        dataId: '',
        published: false,
        images: [],
        description: {
          title: '',
          unit: '',
          host: '',
          spokesman: '',
          intro: '',
          startTime: '',
          address: ''
        },
        content: [],
        bottomFlag: false,
        introDialogVisible: false,
        introDialogTitle: '',
        introDialogContent: '',
        introDialogType: '',
        interval: '',
        startTime:'',
        startNum:0,
        detailvisiable:false
      }
    },
    created() {
      this.dataId = this.$route.query.id;
    },
    mounted() {
      console.log("taskissuestatus start")
      // 根据状态判定是否需要定时刷新
      taskIssueStatus({surveyId: this.dataId}).then(res => {
        if (res.data === 0) {
          this.published = false
        } else {
          this.published = true
          this.desc()
          this.contentM()
          if (res.data === 1) {
            this.bottomFlag = true
            this.interval = setInterval(() => {
              this.contentM()
            }, 2000)
          }
        }
      })
    },
    methods: {
      back() {
        this.$router.push('/list');
      },
      //警告提示
      Messager(text, messageType) {
        this.$message({message: text, type: messageType})
      },
      // 滚动条居底
      scrollBottom() {
        this.$nextTick(() => {
          const h = this.$refs.contentBody.scrollHeight
          this.$refs.contentBody.scrollTop = h
        })
      },
      scrolling() {
        let scrollHeight = this.$refs.contentBody.scrollHeight;
        let clientHeight = this.$refs.contentBody.clientHeight;
        let scrollTop = this.$refs.contentBody.scrollTop;
        if (scrollHeight === (clientHeight + scrollTop)) {
          this.bottomFlag = true
        } else {
          this.bottomFlag = false
        }
      },
      init() {
        this.desc()
        this.contentM()
      },
      desc() {
        issueInfoViewFront({surveyId: this.dataId}).then(res => {
          if (res.status === 200) {
            this.description.title = res.data.survey.title
            this.description.unit = res.data.survey.unit
            this.description.host = res.data.host
            this.description.spokesman = res.data.speaker
            this.description.intro = res.data.survey.intro
            this.description.startTime = getYearMonthDay(res.data.survey.startTime, 'zh')
            this.description.address = res.data.survey.address
            this.startTime = res.data.survey.startTime;
          }
        });

      },
      contentM() {
        let date = new Date().getTime();
        if((this.startTime!='' && date > this.startTime)||this.startNum === 0  ){
          console.log('时间一致')
            this.startNum=1
            console.log("init content start")
            taskIssueStatus({surveyId: this.dataId}).then(res => {
              if(res.data === 0){
                this.published = false
                clearInterval(this.interval);
              }
              if (res.data === 2) {
                if (this.interval) {
                  clearInterval(this.interval);
                }
              }
            })
            speechListFront({surveyId: this.dataId}).then(res => {
              let list = res.data.list
              let image = res.data.image
              if (list.length !== 0) {
                for (let i = 0; i < list.length; i++) {
                  list[i].issueDate = getYearMonthDay(list[i].issueDate, 'yy--ss')
                  list[i].content = lineBrake2Dom(list[i].content, "p")
                }
                this.content = list
                if (this.bottomFlag) {
                  this.scrollBottom()
                }
              } else {
                this.content = []
              }
              let imgTemp = []
              let imgNewTemp = []
              let imgOldTemp = []
              this.images.forEach(imageOld => {
                imgOldTemp.push(imageOld.title)
              })
              image.forEach(imageNew => {
                imgNewTemp.push(imageNew.name)
              })
              this.images.forEach(imageOld => {
                if (imgNewTemp.indexOf(imageOld.title) !== -1) {
                  imgTemp.push(imageOld)
                }
              })
              image.forEach(imageNew => {
                if (imgOldTemp.indexOf(imageNew.name) === -1) {
                  imgTemp.push({img: `${process.env.VUE_APP_FILE_SERVER_URL}/file/attachment/front/downDomain?id=${imageNew.imgId}`, title: imageNew.name})
                }
              })
              this.images = imgTemp
            });
         }
      },
      introDetail() {
        this.introDialogVisible = true
        this.introDialogTitle = "会议内容"
      }
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.scrolling);
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
  };
</script>

<style scoped>
  .view_header {
    height: 125px;
    width: 100%;
    background-image: url('../assets/view/header.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 100% 100%;
  }

  .view_title {
    height: 80px;
    width: 100%;
    background-image: url('../assets/view/title.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 100% 100%;
  }

  .description {
    display: flex;
    margin: 30px 0 30px 0;
  }

  .description_right_img {
    width: 100%;
    position: relative;
  }

  .description_right_text {
    z-index: 2;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 56px;
    width: 100%;
    color: white;
    font-size: 18px;
    background-color: rgb(0 0 0 / 46%);
    line-height: 56px;
  }

  .description_right_title_text {
    font-size: 20px;
    font-family: '黑体';
    margin-bottom: 15px;
  }

  .description_right_content {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 5px;
  }

  .description_right_content_left {
    flex: 16% 0 0;
    font-size: 16px;
    font-weight: 600;
    font-family: '黑体'
  }

  .description_right_content_right {
    height: fit-content;
    max-height: 125px;
    line-height: 25px;
    width: 411px;
    display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
    -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-line-clamp: 5; /* 2行，只有 webkit内核支持 */
    word-break: break-all; /* 纯英文换行 */
    overflow: hidden;
  }

  .content {
    margin-bottom: 10px;
  }


</style>
